import { Alert, Platform } from "react-native";

// react-native-web's Alert.alert is a no-op, so on web the message silently
// never appears (#141: the create button "just doesn't let you click
// through"). Fall back to the browser's alert there.
export function showAlert(title: string, message: string) {
  if (Platform.OS === "web") {
    window.alert(message);
  } else {
    Alert.alert(title, message);
  }
}
